import React, { useRef } from "react";
import "./WorkExerience.css";
import { WORK_EXPERIENCE } from "./utils/data";
import ExperienceCard from "./ExperienceCard";
import Slider from "react-slick";

const WorkExperience = () => {
  const slideRef = useRef();
  const settings = {
    dots: false,
    infinte: true,
    speed: 500,
    slideToShow: 2,
    slideToScroll: 1,
    arrow: false,
    resposive: [
      {
        breakpoint: 769,
        settings: {
          slideToShow: 1,
          slideToScroll: 1,
        },
      },
    ],
  };

  const slideRight = () => {
    slideRef.current.slickNext();
  };

  const slideLeft = () => {
    slideRef.current.slickPrev();
  };
  return (
    <>
      <section className="experience-container">
        <h5>Work Experience</h5>

        <div className="experience-content">
          <div className="arrow-right" onClick={slideRight}>
            <span className="material-symbols-outlined">chevron_right</span>
          </div>

          <div className="arrow-left" onClick={slideLeft}>
            <span className="material-symbols-outlined">chevron_left</span>
          </div>
          <Slider ref={slideRef} {...settings}>
            {WORK_EXPERIENCE.map((item) => (
              <ExperienceCard key={item.title} details={item} />
            ))}
          </Slider>
        </div>
      </section>
    </>
  );
};

export default WorkExperience;
